<template lang="pug">
  .student-progress
    v-sheet.units-column
      v-skeleton-loader(
        v-if="loading.courses"
        type="list-item@3"
      )
      v-list(
        v-if="!selectedCourse"
      )
        v-list-item(v-if="!loading.courses && !courses.length")
          v-list-item-subtitle Курсы не найдены...
        v-list-item-group(
          v-model="selectedCourse"
        )
          v-list-item(
            v-for="(course, idx) in courses"
            :key="idx"
            :value="course"
          )
            v-list-item-avatar
              v-avatar(color="secondary")
                strong.white--text {{ idx + 1 }}
            v-list-item-content
              v-list-item-title.pre-wrap {{ course.title }}
              v-list-item-subtitle(v-if="progressMode && course.unitsPassed")
                span {{ course.unitsPassed.length }}/{{ course.units.length }}
                span  тем пройдено
              v-list-item-subtitle(v-else)
                span Всего тем - {{ course.course_units_count }}
        lazy-load(
          v-model="loadMoreCourses"
          @on-response="({ items }) => courses.push(...items)"
        )
    template(v-if="selectedCourse")
      v-list
        v-list-item(
          class="grey lighten-4"
          @click="selectedUnit = null"
        )
          v-list-item-content.mr-n10.text-center
            v-list-item-title.pre-wrap {{ selectedCourse.title }}
            v-list-item-subtitle(v-if="progressMode")
              span {{ selectedCourse.unitsPassed.length }}/{{ selectedCourse.units.length }}
              span  тем пройдено
            v-list-item-subtitle(v-else)
              span Всего тем - {{ selectedCourse.course_units_count }}
          v-list-item-avatar
            v-btn(
              fab
              @click.stop="selectedCourse = null"
            )
              v-icon mdi-close

      v-row
        v-col
          .mt-2 Темы
          v-sheet.units-column
            v-skeleton-loader(
              v-if="loading.units"
              type="list-item@3"
            )
            v-list(v-else)
              v-list-item(
                v-for="(unit, idx) in selectedCourse.units"
                :key="idx"
                @click="selectedUnit = unit; selectedLesson = null"
              )
                v-list-item-avatar
                  v-progress-circular(
                    v-if="progressMode"
                    width="20"
                    size="40"
                    :color="unit.statusColor"
                    :value="unit.progress"
                  )
                  v-avatar(
                    v-else
                    color="secondary"
                  )
                    strong.white--text {{ idx + 1 }}
                v-list-item-content
                  v-list-item-title.pre-wrap
                    span {{ unit.title }}
                  v-list-item-subtitle(v-if="progressMode")
                    span {{ unit.lessonsPassed.length }}/{{ unit.lessons.length }}
                    span  уроков завершено
                  v-list-item-subtitle(v-else-if="showFaq")
                    span Вопросов - {{unit.faq.length}}
                  v-list-item-subtitle(v-else)
                    span Уроков - {{ unit.lessons.length }}
        v-col(v-if="selectedUnit && !withoutLesson")
          .mt-2 Уроки
          v-sheet(ref="lessons").units-column
            v-list
              v-list-item(
                v-if="!selectedUnit.lessons.length"
              )
                v-list-item-content
                  v-list-item-subtitle В теме нет уроков...
              v-list-item(
                v-for="(lesson, idx) in selectedUnit.lessons"
                :key="idx"
                :class="{ 'sdo-active-dark': selectedLesson === lesson }"
                @click="selectedLesson = lesson"
              )
                v-list-item-avatar
                  v-progress-circular(
                    v-if="progressMode"
                    width="20"
                    size="40"
                    :color="lesson.statusColor"
                    :value="lesson.progress"
                  )
                  v-avatar(
                    v-else
                    color="secondary"
                  )
                    strong.white--text {{ idx + 1 }}
                v-list-item-content
                  v-list-item-title.pre-wrap {{ lesson.name }}
                  v-list-item-subtitle(v-if="progressMode")
                    | {{ lesson.tasksPassed.length }}/{{ lesson.tasks.length }}
                    |  заданий пройдено
                  v-list-item-subtitle(v-else)
                    span Заданий - {{ lesson.tasks.length }}
</template>

<script>
export default {
  props: {
    getCoursesMethod: { type: Function, required: true },
    progressMode: { type: Boolean, default: false },
    withoutLesson: { type: Boolean, default: false },
    showFaq: { type: Boolean, default: false },
  },
  data() {
    return {
      courses: [],
      loadMoreCourses: null,

      selectedCourse: null,
      selectedUnit: null,
      selectedLesson: null,

      loading: {
        courses: true,
        units: false,
      },
    };
  },
  computed: {
    subject() {
      let val = this.selectedCourse && this.selectedUnit && this.selectedLesson;
      if (!val) val = this.selectedCourse && this.selectedUnit;
      if (!val) val = this.selectedCourse;
      return val;
    },
  },
  watch: {
    selectedCourse(val) {
      this.selectedUnit = null;
      this.selectedLesson = null;
      if (!this.progressMode && val) {
        this.fetchUnits();
      }
    },
    selectedUnit() {
      this.selectedLesson = null;
      this.$vuetify.goTo(0, { container: this.$refs.lessons });
    },
    subject(val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      this.loading.courses = true;
      const { items, loadMore } = await this.getCoursesMethod();
      this.courses = items;
      this.loadMoreCourses = loadMore;
      this.loading.courses = false;
    },
    async fetchUnits() {
      this.loading.units = true;
      await this.selectedCourse.fetchUnits(false, { expand: 'faq,lessons,tasks,user_passed,user_tasks' });
      this.loading.units = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.units-column {
  @include sdo-dark-scrollbar();

  max-height: calc(100vh - 350px);
  overflow-y: scroll;
}
</style>
